import { contentStyles } from "../Content";

const legalContentStyles = {
  ...contentStyles,
  heading: {
    ...contentStyles.heading,
    counterIncrement: "orderedlist",
  },
  list: {
    ...contentStyles.list,
    listStyle: "none",
    li: { counterIncrement: "clause", position: "relative", ...contentStyles.list.li },
    "li::before": {
      content: "counter(orderedlist) '.' counters(clause, '.')",
      position: "absolute",
      left: -8,
      fontSize: "lg",
      color: "primary.500",
    },
    "li > ol > li": {
      counterIncrement: "unset",
      listStyleType: "lower-roman",
    },
    "li > ol > li::before": {
      content: `""`,
    },
  },
};

export default legalContentStyles;
